import { UPDATE_SELECTED_MAX_CAP_FAILURE, UPDATE_SELECTED_MAX_CAP_REQUEST, UPDATE_SELECTED_MAX_CAP_RESET, UPDATE_SELECTED_MAX_CAP_SUCCESS } from "redux/actions/action-type";

const initialState = {
    isUpdateSelectedLoading: false,
    isUpdateSelectedSuccess: false,
    isUpdateSelectedFail: false,
    updateSelectedMaxCapResponse: {},
};

export const updateSelectedMaxCapReducer = (state = initialState, { type, updateSelectedMaxCapResponse }) => {
    switch (type) {
        case UPDATE_SELECTED_MAX_CAP_REQUEST:
            return {
                ...state,
                isUpdateSelectedLoading: true,
                isUpdateSelectedSuccess: false,
                isUpdateSelectedFail: false,
            };
        case UPDATE_SELECTED_MAX_CAP_SUCCESS:
            return {
                ...state,
                updateSelectedMaxCapResponse: updateSelectedMaxCapResponse,
                isUpdateSelectedLoading: false,
                isUpdateSelectedSuccess: true,
                isUpdateSelectedFail: false,
            };
        case UPDATE_SELECTED_MAX_CAP_FAILURE:
            return {
                ...state,
                updateSelectedMaxCapResponse: updateSelectedMaxCapResponse,
                isUpdateSelectedLoading: false,
                isUpdateSelectedSuccess: false,
                isUpdateSelectedFail: true,
            };
        case UPDATE_SELECTED_MAX_CAP_RESET:
            return { ...initialState };
        default:
            return { ...state };
    }
};
